module.exports = __webpack_public_path__ + "img/bouy.f8982e7a.png";